<template>
    <section role="list" class="module" :class="'module'">
        <div class="posts-row">
            <postBlock v-for="(postId, i) in data" size="large" :key="i" :id="postId" :type="postType"/>
        </div>
    </section>
</template>

<script>
import postBlock from '@/components/blocks/postBlock'

export default {
    name: 'related-posts-module',
    props: ['data', 'type'],
    computed: {
        postType(){
            return this.type || 'post'
        }
    },
    components: {
        postBlock
    },
    data(){
        const VM = this
        return{
            relatedPosts: null
        }
    }
}
</script>